import React, { useState } from 'react';
import TopNav from '../components/TopNav';
import SideIcons from '../components/SideIcons';
import ComposeModal from '../components/ComposeModal';
import Footer from '../components/Footer';
import { postsAPI } from '../api';
import './Listening.css';

const Listening = () => {
  const [isComposeModalOpen, setIsComposeModalOpen] = useState(false);

  const handleComposeClick = () => {
    setIsComposeModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsComposeModalOpen(false);
  };

  const handleSubmitPost = async (postData, postId = null) => {
    try {
      if (postId) {
        await postsAPI.update(postId, postData);
      } else {
        await postsAPI.create(postData);
      }
    } catch (error) {
      console.error('Error saving post:', error);
      throw error;
    }
  };
  return (
    <div className="listening-page">
      <TopNav activePage="listening" onComposeClick={handleComposeClick} />
      <SideIcons />

      <main className="listening-container">
        <h1>Social Listening</h1>
        <p className="subtitle">Monitor keywords, mentions, and conversations across platforms</p>
        
        <div className="content-placeholder">
          <p>Listening features coming soon...</p>
        </div>
      </main>

      <ComposeModal 
        isOpen={isComposeModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitPost}
      />
      <Footer />
    </div>
  );
};

export default Listening;
